import { createCrudPage } from './factories/crud-page.js';

export default createCrudPage({
  title: 'Object Types',
  basePath: '/itemserver-object-types',
  columns: [
    { key: 'title', label: 'Title', sortable: true },
    { key: 'width', label: 'Width', sortable: true },
    { key: 'height', label: 'Height', sortable: true },
    { key: 'recommended_size', label: 'Recommended size', sortable: true },
    { key: 'proportion', label: 'Proportion', sortable: true },
    { key: 'description', label: 'Description', sortable: true },
    { key: 'show_photo_title', label: 'Show photo title', sortable: true,
      render: (v) => (/** @type {unknown} */ (v) === 1 || v === '1' || v === true) ? 'Yes' : 'No' },
    { key: 'suggested_weight', label: 'Suggested file weight', sortable: true },
  ],
  fields: [
    { key: 'title', label: 'Title', type: 'text', required: true },
    { key: 'width', label: 'Width', type: 'text' },
    { key: 'height', label: 'Height', type: 'text' },
    { key: 'recommended_size', label: 'Recommended size', type: 'text' },
    { key: 'proportion', label: 'Proportion', type: 'text' },
    { key: 'description', label: 'Description', type: 'text' },
    { key: 'show_photo_title', label: 'Show photo title', type: 'yesno', defaultValue: 0 },
    { key: 'suggested_weight', label: 'Suggested file weight', type: 'text' },
  ],
  rowActions: [{ key: 'edit', label: 'Edit' }],
});
